export default __webpack_public_path__ + "static/media/webconference.533902ba.jpg";